module.exports = __webpack_public_path__ + "static/media/logo.c79fdbe4.png";